function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { format } from 'date-fns';
import { InvoiceAccountingSyncStatusFilter } from 'anchor-scout-common/types';
import { AccountingStatusFilter } from "../business-logic/qboStatusFilterLogic";
import { ServerError } from "../infra/ErrorResponse";
import { UserInfoModel, MemberModel, invoiceModel, BillingControlDataModel, ActivityLogEntryModel, AccountantModel, HistoricAgreementStatsModel, PayoutsSummaryModel, ReferralModel, integrationModel, invoiceDraftModel, proposalTemplateModel, relationshipModel, relationshipSummaryModel, serviceModel, serviceTemplateModel, timeModel, LatestOFACSanctionStatusModel, ProposalTemplateSummaryModel, SalesSummaryModel, TimeActivitiesModel } from "../models";
import { AccountingCustomerModel } from "../models/AccountingCustomerModel";
import { BusinessSettingsModel } from "../models/BusinessSettingsModel";
import { ContactModel } from "../models/ContactModel";
import { DraftModel } from "../models/DraftModel";
import { EmailOnBehalfSettingsModel } from "../models/EmailOnBehalfSettingsModel";
import { FutureInvoiceModel } from "../models/FutureInvoiceModel";
import { HistoricRevenueModel } from "../models/HistoricRevenueModel";
import { InvoiceDraftDatesModel } from "../models/InvoiceDraftDatesModel";
import { InvoicesDigestModel } from "../models/invoices-digest/InvoicesDigestModel";
import { PayoutModel } from "../models/PayoutModel";
import { RecipientModel } from "../models/RecipientModel";
import { ServiceStatusType } from "../models/service/model";
import { ServiceInvoiceModel } from "../models/ServiceInvoiceModel";
import { TeamInviteModel } from "../models/TeamInvitesModel";
import { fromDateStampObject } from "../models/time";
import { getProposalsReportFilterParams } from "../pages/Reports/ProposalsReport/ProposalsReport.utils";
import { AccountingItemType } from "../types/api/accounting-integration";
import { IntegrationResponseStatus } from "../types/api.model";
import { utils } from "../utils";
import { buildRelationshipsParamsFilter } from "../utils/relationships-params-filter-builder";
import { APIHost } from "./sendRequest";
import { selectors } from "./state-selectors";
export function initStoreApi(_ref) {
  let {
    getState,
    getNow,
    sendRequest
  } = _ref;
  const mapResponseBody = res => res.data;
  return {
    charge: {
      approveAll(relationshipId) {
        return sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/billing/".concat(relationshipId, "/charge/approve"),
          urlForSentry: '/billing/:id/charge/approve',
          data: {}
        }).then(mapResponseBody);
      },
      async approve(relationshipId, chargeId) {
        await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/billing/".concat(relationshipId, "/charge/").concat(chargeId, "/approve"),
          urlForSentry: '/billing/:id/charge/:id/approve'
        });
      },
      async delete(relationshipId, chargeId) {
        await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/billing/".concat(relationshipId, "/charge/").concat(chargeId, "/cancel"),
          urlForSentry: '/billing/:id/charge/:id/cancel',
          disableSentry: err => err.hasServerError(ServerError.AdHocChargeNotFound)
        });
      },
      async deleteCredit(relationshipId, chargeId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/billing/".concat(relationshipId, "/credit/").concat(chargeId, "/cancel"),
          urlForSentry: '/billing/:id/credit/:id/cancel'
        });
      },
      async pauseCredit(relationshipId, chargeId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/billing/".concat(relationshipId, "/credit/").concat(chargeId, "/pause"),
          urlForSentry: '/billing/:id/credit/:id/pause'
        });
      },
      async resumeCredit(relationshipId, chargeId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/billing/".concat(relationshipId, "/credit/").concat(chargeId, "/resume"),
          urlForSentry: '/billing/:id/credit/:id/resume'
        });
      }
    },
    service: {
      async togglePauseResumeBilling(relationshipId, serviceId, pause) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/".concat(relationshipId, "/service/").concat(serviceId, "/pause"),
          urlForSentry: '/relationship/:id/service/:id/pause',
          data: {
            pause
          }
        });
      },
      nextBillingDate(relationshipId, serviceId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/relationship/".concat(relationshipId, "/service/").concat(serviceId, "/next-billing-date"),
          urlForSentry: '/relationship/:id/service/:id/next-billing-date'
        }).then(res => timeModel.fromDateStampObject(res.data.date));
      },
      async getPromptSuggestions() {
        return sendRequest({
          apiHost: APIHost.AI,
          method: 'get',
          url: '/api/service-description/conversations/suggestions',
          urlForSentry: '/api/service-description/conversations/suggestions'
        }).then(mapResponseBody);
      },
      async generateDescriptionFromTitle(data) {
        return sendRequest({
          apiHost: APIHost.AI,
          method: 'post',
          url: '/api/service-description/conversations/title',
          urlForSentry: '/api/service-description/conversations/title',
          data
        }).then(mapResponseBody);
      },
      async generateDescriptionFromDescription(data) {
        return sendRequest({
          apiHost: APIHost.AI,
          method: 'post',
          url: '/api/service-description/conversations/description',
          urlForSentry: '/api/service-description/conversations/description',
          data
        }).then(mapResponseBody);
      },
      async generateDescriptionFromMessage(data) {
        return sendRequest({
          apiHost: APIHost.AI,
          method: 'post',
          url: "/api/service-description/conversations/".concat(data.conversationId, "/messages"),
          urlForSentry: "/api/service-description/conversations/:conversationId/messages",
          data: {
            type: data.type,
            message: data.message
          }
        }).then(mapResponseBody);
      },
      async generateDescriptionFromPreset(data) {
        return sendRequest({
          apiHost: APIHost.AI,
          method: 'post',
          url: "/api/service-description/conversations/".concat(data.conversationId, "/messages"),
          urlForSentry: "/api/service-description/conversations/:conversationId/messages",
          data: {
            type: data.type,
            preset: data.preset
          }
        }).then(mapResponseBody);
      },
      async undoDescription(conversationId) {
        return sendRequest({
          apiHost: APIHost.AI,
          method: 'post',
          url: "/api/service-description/conversations/".concat(conversationId, "/undo"),
          urlForSentry: "/api/service-description/conversations/:conversationId/undo"
        }).then(mapResponseBody);
      },
      async acceptServiceDescription(conversationId) {
        return sendRequest({
          apiHost: APIHost.AI,
          method: 'post',
          url: "/api/service-description/conversations/".concat(conversationId, "/accept"),
          urlForSentry: "/api/service-description/conversations/:conversationId/accept",
          data: {}
        }).then(mapResponseBody);
      },
      async rejectServiceDescription(conversationId) {
        return sendRequest({
          apiHost: APIHost.AI,
          method: 'post',
          url: "/api/service-description/conversations/".concat(conversationId, "/reject"),
          urlForSentry: "/api/service-description/conversations/:conversationId/reject",
          data: {}
        }).then(mapResponseBody);
      },
      async submitServiceDescriptionFeedback(conversationId, data) {
        return sendRequest({
          apiHost: APIHost.AI,
          method: 'post',
          url: "/api/service-description/conversations/".concat(conversationId, "/feedback"),
          urlForSentry: "/api/service-description/conversations/:conversationId/feedback",
          data
        }).then(mapResponseBody);
      }
    },
    billing: {
      submitCharges(relationshipId, data) {
        return sendRequest({
          method: 'post',
          apiHost: APIHost.External,
          url: "/billing/".concat(relationshipId, "/submit"),
          urlForSentry: '/billing/:id/submit',
          data
        }).then(mapResponseBody);
      },
      addCredit(relationshipId, data) {
        return sendRequest({
          method: 'post',
          apiHost: APIHost.External,
          url: "/billing/".concat(relationshipId, "/credit"),
          urlForSentry: '/billing/:id/credit',
          data
        }).then(mapResponseBody);
      },
      bulk: {
        upload(fileContent) {
          return sendRequest({
            method: 'post',
            apiHost: APIHost.Mgmt,
            url: "/billing/bulk/upload",
            data: fileContent,
            config: {
              headers: {
                'Content-Type': 'text/csv'
              }
            }
          }).then(mapResponseBody);
        },
        uploadResult(bulkUploadId) {
          return sendRequest({
            method: 'get',
            apiHost: APIHost.Mgmt,
            url: "/billing/bulk/upload/".concat(bulkUploadId, "/results"),
            urlForSentry: 'bulk/upload/:bulkUploadId/results'
          }).then(mapResponseBody);
        },
        billClients(bulkUploadId) {
          return sendRequest({
            method: 'post',
            apiHost: APIHost.Mgmt,
            url: "/billing/bulk/upload/".concat(bulkUploadId, "/submit"),
            urlForSentry: '/billing/bulk/upload/:bulkUploadId/submit',
            data: bulkUploadId,
            config: {
              headers: {
                'Content-Type': 'text/csv'
              }
            },
            disableSentry: err => err.hasServerError(ServerError.BulkBillAlreadyInProgress)
          }).then(mapResponseBody);
        },
        getBillClientsResult(bulkUploadId) {
          return sendRequest({
            method: 'get',
            apiHost: APIHost.Mgmt,
            url: "/billing/bulk/billing/".concat(bulkUploadId, "/results"),
            urlForSentry: '/billing/bulk/billing/:bulkUploadId/results'
          }).then(mapResponseBody);
        }
      },
      getBillingSchedule(data, params) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/billing/billing-schedule",
          urlForSentry: '/billing/billing-schedule',
          data,
          params
        }).then(mapResponseBody);
      }
    },
    billCommand: {
      async remove(relationshipId, serviceId, billCommandId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/".concat(relationshipId, "/service/").concat(serviceId, "/bill-command/").concat(billCommandId, "/cancel"),
          urlForSentry: '/relationship/:id/service/:id/bill-command/:id/cancel'
        });
      }
    },
    texts: {
      getLegalTermsRichTextContent(sourceId, textId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/texts/".concat(sourceId, "/").concat(textId),
          urlForSentry: '/texts/:sourceId/:id'
        }).then(mapResponseBody);
      }
    },
    relationship: {
      serviceBillingDetails(service, effectiveDate) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/service-billing-details",
          urlForSentry: '/relationship/service-billing-details',
          data: {
            service,
            effectiveDate
          },
          allowedForAccountants: true
        }).then(res => {
          return {
            periods: res.data.periods,
            nextBillingDate: res.data.nextBillingDate ? fromDateStampObject(res.data.nextBillingDate) : null
          };
        });
      },
      getServiceNames(businessId, isVendor, type) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/business/".concat(businessId, "/relationships-summary-mv/service-names"),
          urlForSentry: '/business/:id/relationships-summary-mv/service-names',
          params: {
            party: isVendor ? 'vendor' : 'customer',
            status: type === 'agreement' ? "".concat(ServiceStatusType.Approved, ",").concat(ServiceStatusType.Terminated) : ServiceStatusType.AwaitingApproval
          }
        }).then(res => res.data.map(obj => obj.serviceName));
      },
      getSummaries(config) {
        const {
          businessId
        } = config;
        const filterParams = buildRelationshipsParamsFilter(config);
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/business/".concat(businessId, "/relationships-summary-mv"),
          urlForSentry: '/business/:id/relationships-summary-mv',
          params: filterParams
        }).then(res => (res.data || []).map(relationshipSummaryModel.fromDTO));
      },
      getProposalsReportSummaries(_ref2) {
        let {
          isVendor,
          businessId,
          filters
        } = _ref2;
        const filterParams = getProposalsReportFilterParams(filters, isVendor);
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/business/".concat(businessId, "/relationships-summary-mv"),
          urlForSentry: '/business/:id/relationships-summary-mv',
          params: _objectSpread({}, filterParams)
        }).then(res => (res.data || []).map(relationshipSummaryModel.fromDTO));
      },
      /** Returns null if didn't connect any payment-method. */
      getSelectedPaymentMethod(relationshipId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/relationship/".concat(relationshipId, "/funding-source"),
          urlForSentry: '/relationship/:id/funding-source'
        }).then(res => res.data.details);
      },
      async changePaymentMethod(relationshipId, fundingSourceId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/".concat(relationshipId, "/funding-source/").concat(fundingSourceId),
          urlForSentry: '/relationship/:id/funding-source/:id',
          allowedForAccountants: true
        });
      },
      async disconnectPaymentMethod(relationshipId) {
        await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/relationship/".concat(relationshipId, "/disconnect-payment-method"),
          urlForSentry: '/relationship/:id/disconnect-payment-method'
        });
      },
      createFromDraft(draftId) {
        let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: opts.externallySign ? '/relationship/approve/draft/vendor' : '/relationship/create-from-draft',
          data: {
            draftId,
            notifyPolicy: opts.sendSilently ? 'silent' : 'notify'
          },
          disableSentry: e => e.createRelationshipDisableSentry()
        }).then(mapResponseBody);
      },
      get(relationshipId) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const {
          resolvePaymentMethod
        } = options;
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/relationship/".concat(relationshipId),
          urlForSentry: '/relationship/:id',
          params: {
            resolvePaymentMethod
          }
        }).then(res => relationshipModel.fromDTO(res.data));
      },
      getOriginalProposal(id) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/relationship/".concat(id, "/latest-proposal"),
          urlForSentry: '/relationship/:id/latest-proposal'
        }).then(mapResponseBody).then(relationshipModel.fromDTO);
      },
      /** Returns the new relationship version. */
      async updateOld(relationshipId, body) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/".concat(relationshipId, "/update"),
          urlForSentry: "/relationship/:id/update",
          data: body,
          disableSentry: err => err.hasServerError(ServerError.MismatchingRelationshipVersion)
        });
        return res.data;
      },
      /** Returns the new relationship version. */
      async update(relationshipId, body) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/".concat(relationshipId, "/updateV2"),
          urlForSentry: "/relationship/:id/updateV2",
          data: body,
          disableSentry: err => err.hasServerError(ServerError.MismatchingRelationshipVersion)
        });
        return res.data;
      },
      async approve(relationshipData, additionalData) {
        const {
          id,
          version
        } = relationshipData;
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/".concat(id, "/approve/buyer"),
          urlForSentry: '/relationship/:id/approve/buyer',
          data: _objectSpread({
            version
          }, additionalData),
          disableSentry: err => err.hasServerError([ServerError.MismatchingRelationshipVersion, ServerError.InvalidRelationshipStatus, ServerError.UserAlreadySigned])
        });
      },
      async signatoryApprove(relationshipData, additionalData) {
        const {
          id,
          version
        } = relationshipData;
        const {
          fundingSourceId,
          requestAccountantAccessApproved
        } = additionalData;
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/".concat(id, "/approve/signatory"),
          urlForSentry: '/relationship/:id/approve/signatory',
          data: {
            version,
            fundingSourceId,
            requestAccountantAccessApproved
          },
          disableSentry: err => err.hasServerError([ServerError.MismatchingRelationshipVersion, ServerError.InvalidRelationshipStatus, ServerError.UserAlreadySigned])
        });
      },
      async terminateAgreement(relationshipId, notification) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/".concat(relationshipId, "/terminate"),
          urlForSentry: '/relationship/:id/terminate',
          data: notification ? {
            action: 'notify',
            notification
          } : {
            action: 'silent'
          },
          disableSentry: e => e.hasServerError(ServerError.RelationshipAlreadyTerminated)
        });
      },
      async requestPaymentMethod(relationshipId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/".concat(relationshipId, "/request-payment-method"),
          urlForSentry: '/relationship/:id/request-payment-method'
        });
      },
      getNextReminder(relationshipId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/relationship/".concat(relationshipId, "/next-reminder"),
          urlForSentry: '/relationship/:id/next-reminder'
        }).then(mapResponseBody);
      },
      async associateCustomer(relationshipId, customerId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/".concat(relationshipId, "/associate-customer"),
          urlForSentry: '/relationship/:id/associate-customer',
          data: {
            customerId
          }
        });
      },
      async stopAutoApproveAmendments(relationshipId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/".concat(relationshipId, "/stop-auto-approve-amendments"),
          urlForSentry: '/relationship/:id/stop-auto-approve-amendments'
        });
      },
      getSingleUseApprovalLink(relationshipId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          disableAuth: true,
          method: 'get',
          url: "/relationship/".concat(relationshipId, "/single-use-approval-link"),
          urlForSentry: '/relationship/:id/single-use-approval-link',
          disableSentry: err => err.hasServerError(ServerError.RelationshipAlreadyApproved)
        }).then(mapResponseBody);
      },
      getProposalLinks(relationshipId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/relationship/".concat(relationshipId, "/proposal-links"),
          urlForSentry: '/relationship/:id/proposal-links',
          disableSentry: err => err.hasServerError(ServerError.RelationshipAlreadyApproved)
        }).then(res => {
          return {
            primary: RecipientModel.fromDTO(res.data.primary),
            additionalRecipients: res.data.additionalRecipients.map(RecipientModel.fromDTO)
          };
        });
      },
      getBillingControlData(relationshipId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/billing/".concat(relationshipId, "/control-data"),
          urlForSentry: '/billing/:id/control-data'
        }).then(res => BillingControlDataModel.fromDTO(res.data));
      },
      async sendProposalApprovalReminder(relationshipId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/".concat(relationshipId, "/reminder/proposal-approval"),
          urlForSentry: '/relationship/:id/reminder/proposal-approval'
        });
      },
      async cancelProposal(relationshipId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/".concat(relationshipId, "/cancel"),
          urlForSentry: '/relationship/:id/cancel',
          disableSentry: err => err.hasServerError(ServerError.InvalidRelationshipStatus)
        });
      },
      /** Will get a direct link to a relationship or an invoice, depending on the payload provided. */
      getDirectLink(relationshipId, data) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/".concat(relationshipId, "/direct-link"),
          urlForSentry: '/relationship/:id/direct-link',
          allowedForAccountants: true,
          data: {
            data: {
              [data.type]: data.id
            }
          }
        }).then(mapResponseBody);
      },
      async approveAllInvoices(relationshipId) {
        await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/relationship/".concat(relationshipId, "/approve-invoices"),
          urlForSentry: '/relationship/:id/approve-invoices',
          data: {}
        });
      },
      /** Updates the progressStatus of an agreement. */
      async updateProgressStatus(agreementId, progressStatus) {
        await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/relationship/".concat(agreementId, "/approval-progress"),
          urlForSentry: '/relationship/:id/approval-progress',
          data: {
            progressStatus
          },
          allowedForAccountants: true
        });
      },
      approveAllAmendments(relationshipId, relationshipVersion, amendmentVersion) {
        return sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/relationship/".concat(relationshipId, "/approve-amendments"),
          urlForSentry: '/relationship/:id/approve-amendments',
          data: {
            version: relationshipVersion,
            amendmentVersion
          },
          disableSentry: err => err.hasServerError([ServerError.MismatchingRelationshipVersion, ServerError.InvalidRelationshipStatus, ServerError.RelationshipAlreadyTerminated])
        }).then(mapResponseBody);
      },
      approveAmendmentFromEmail(_ref3) {
        let {
          approvalToken
        } = _ref3;
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/approve-amendments-by-token",
          data: {
            approvalToken
          },
          disableSentry: err => err.hasServerError([ServerError.MismatchingRelationshipVersion, ServerError.RelationshipAlreadyTerminated, ServerError.NoAmendmentsToApprove])
        }).then(mapResponseBody);
      }
    },
    draft: {
      getFullDrafts(params) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/relationship-drafts',
          params
        }).then(mapResponseBody).then(drafts => drafts.map(DraftModel.fromDTO));
      },
      getSummaries() {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/relationship-drafts/summary'
        }).then(mapResponseBody);
      },
      getArchivedSummaries() {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/relationship-drafts/summary',
          urlForSentry: '/relationship-drafts/summary?statuses=archived',
          params: {
            statuses: 'archived'
          }
        }).then(mapResponseBody);
      },
      getById(draftId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/relationship-drafts/".concat(draftId),
          urlForSentry: '/relationship-drafts/:id'
        }).then(res => DraftModel.fromDTO(res.data));
      },
      save(data) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/relationship-drafts/',
          data
        }).then(mapResponseBody);
      },
      duplicate(draftId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship-drafts/".concat(draftId, "/duplicate"),
          urlForSentry: "/relationship-drafts/:id/duplicate",
          data: {}
        }).then(mapResponseBody);
      },
      async deleteById(draftId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'delete',
          url: "/relationship-drafts/".concat(draftId),
          urlForSentry: '/relationship-drafts/:id'
        });
      },
      createScheduledProposal(data) {
        return sendRequest({
          apiHost: APIHost.External,
          method: 'post',
          url: "/proposal-drafts/".concat(data.draftId, "/schedule"),
          data: {
            time: data.time
          },
          disableSentry: err => err.hasServerError([ServerError.DraftAlreadyScheduled, ServerError.MissingDraftOwnerDetails, ServerError.InvalidScheduleTime])
        }).then(mapResponseBody);
      },
      cancelScheduledProposal(data) {
        return sendRequest({
          apiHost: APIHost.External,
          method: 'post',
          url: "/proposal-drafts/".concat(data.draftId, "/cancel-schedule"),
          data: {}
        }).then(mapResponseBody);
      },
      unarchive(draftId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship-drafts/".concat(draftId, "/unarchive"),
          urlForSentry: '/relationship-drafts/:id/unarchive',
          data: {}
        }).then(mapResponseBody);
      },
      archive(draftId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship-drafts/".concat(draftId, "/archive"),
          urlForSentry: '/relationship-drafts/:id/archive',
          data: {}
        }).then(mapResponseBody);
      }
    },
    contact: {
      getAll() {
        return sendRequest({
          method: 'get',
          apiHost: APIHost.Mgmt,
          url: '/clients'
        }).then(mapResponseBody).then(contacts => contacts.map(c => new ContactModel(c)));
      },
      getById(contactId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/clients/".concat(contactId),
          urlForSentry: '/clients/:id'
        }).then(res => new ContactModel(res.data));
      },
      create(newContact) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/clients',
          data: _objectSpread(_objectSpread({}, newContact.toJSON()), {}, {
            isSample: false
          }),
          disableSentry: e => e.hasPhoneValidationError() || e.hasServerError([ServerError.DuplicateContact, ServerError.UserWithEmailAlreadyExists])
        }).then(res => new ContactModel(res.data));
      },
      async update(contact) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/clients/".concat(contact.id(), "/update"),
          urlForSentry: '/clients/:id/update',
          data: {
            firstName: contact.firstName(),
            lastName: contact.lastName(),
            companyName: contact.companyName(),
            email: contact.email(),
            phone: contact.phone(),
            version: contact.version()
          },
          disableSentry: e => e.hasPhoneValidationError() || e.hasServerError([ServerError.DuplicateContact, ServerError.ContactVersionMismatch, ServerError.ContactNotEditable, ServerError.UserWithEmailAlreadyExists])
        });
        return new ContactModel(res.data);
      },
      updateV2(contactId, data) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/contacts/".concat(contactId),
          urlForSentry: '/contacts/:id/update',
          data,
          disableSentry: e => e.hasPhoneValidationError() || e.hasServerError([ServerError.DuplicateContact, ServerError.ContactVersionMismatch, ServerError.ContactNotEditable, ServerError.UserWithEmailAlreadyExists])
        }).then(mapResponseBody);
      },
      async archive(contactId, data) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/clients/".concat(contactId, "/archive"),
          urlForSentry: '/clients/:id/archive',
          data,
          disableSentry: err => err.hasServerError([ServerError.FailedToArchiveContactDueToExistingRelationships, ServerError.ContactVersionMismatch])
        });
      },
      async restore(contactId, data) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/clients/".concat(contactId, "/restore"),
          urlForSentry: '/clients/:id/restore',
          data,
          disableSentry: err => err.hasServerError(ServerError.ContactVersionMismatch)
        });
      },
      qboCreate(contactId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/clients/".concat(contactId, "/qbo-create"),
          urlForSentry: '/clients/:id/qbo-create',
          disableSentry: err => err.hasServerError(ServerError.DuplicateNameExists)
        }).then(mapResponseBody);
      }
    },
    auth: {
      loginEmailStep(email, pageUrl) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/login/flow/".concat(email),
          urlForSentry: '/login/flow/:email',
          disableAuth: true,
          config: {
            headers: {
              'Anchor-Referrer': pageUrl
            }
          }
        }).then(mapResponseBody);
      },
      loginWithPassword(data) {
        const {
          email,
          password,
          utms,
          anchorReferrer
        } = data;
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/login',
          data: {
            email,
            password,
            utms
          },
          disableSentry: err => err.hasStatus([400]),
          config: {
            headers: {
              'Anchor-Referrer': anchorReferrer
            }
          }
        }).then(mapResponseBody);
      },
      async xeroSignUp(data) {
        const res = await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: '/integrations/accounting/xero/sign-up',
          data
        });
        return res.data;
      },
      async xeroSignIn(data) {
        const res = await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: '/integrations/accounting/xero/sign-in',
          data
        });
        return res.data;
      },
      async qboSignUp(data) {
        const res = await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: '/integrations/accounting/qbo/sign-up',
          data
        });
        return res.data;
      },
      async qboSignIn(data) {
        const res = await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: '/integrations/accounting/qbo/sign-in',
          data
        });
        return res.data;
      },
      async intuitSignIn(_ref4) {
        let {
          redirectUrl,
          authDomain,
          utms,
          ensureEmail
        } = _ref4;
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/qbo-integration/sign-in',
          data: ensureEmail ? {
            redirectUrl,
            authDomain,
            utms,
            ensureEmail
          } : {
            redirectUrl,
            authDomain,
            utms
          }
        });
        return res.data;
      },
      async signupOld(_ref5) {
        let {
          fullName,
          email,
          password,
          utms,
          pageUrl
        } = _ref5;
        const res = await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: '/signup-old',
          data: {
            fullName,
            email,
            password,
            utms
          },
          disableSentry: err => err.hasStatus([400, 409]),
          config: {
            headers: {
              'Anchor-Referrer': pageUrl
            }
          }
        });
        return res.data;
      },
      async signup(_ref6) {
        let {
          fullName,
          email,
          password,
          utms,
          pageUrl
        } = _ref6;
        const res = await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: '/signup',
          data: {
            fullName,
            email,
            password,
            utms
          },
          disableSentry: err => err.hasStatus([400, 409]),
          config: {
            headers: {
              'Anchor-Referrer': pageUrl
            }
          }
        });
        return res.data;
      },
      async approveTos(userId) {
        await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/user/".concat(userId, "/approve-tos"),
          urlForSentry: '/user/:id/approve-tos'
        });
      },
      async setPassword(password) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/user/password/set',
          data: {
            password
          },
          forceAuthorizationHeader: true
        });
      },
      getUserInfo() {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/user/me?expand=worksAt",
          disableSentry: err => err.hasStatus([401])
        }).then(res => res.data ? UserInfoModel.fromDTO(res.data) : null).catch(err => {
          var _err$response;
          if (((_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 401) {
            // This will happen when the user is removed from his team by another team-member.
            // Should trigger an automatic logout.
            return null;
          }
          throw err;
        });
      },
      getUserVideos() {
        return sendRequest({
          method: 'get',
          url: "/users/videos",
          apiHost: APIHost.Scout
        }).then(mapResponseBody);
      },
      editUserDetails(userDetails) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/user/me',
          allowedForAccountants: true,
          data: userDetails,
          disableSentry: err => err.hasStatus([400])
        }).then(mapResponseBody);
      },
      googleSignIn(_ref7) {
        let {
          pageUrl,
          idToken,
          utms,
          ensureEmail
        } = _ref7;
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/oauth',
          data: {
            provider: 'google',
            id_token: idToken,
            utms,
            ensureEmail
          },
          config: {
            headers: {
              'Anchor-Referrer': pageUrl
            }
          },
          disable403Handling: true,
          disableSentry: err => err.hasStatus([403]) || err.hasServerError([ServerError.EmailIsInvalid]) //an invalid email or 429, both ignored in Sentry
        }).then(res => res.data.authToken);
      },
      async resetPassword(email) {
        await sendRequest({
          method: 'post',
          url: '/api/forgot-password/reset',
          data: {
            email
          },
          disableAuth: false,
          forceAuthorizationHeader: true,
          apiHost: APIHost.Old
        });
      },
      async resendEmailVerification(email) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/resend-email-verification',
          data: {
            recipient: email
          },
          disableAuth: true
        });
      },
      requestNewOTP(email) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/login/otp/send',
          data: {
            email
          },
          disableSentry: err => err.hasStatus([429]) //429 is ignored in Sentry
        }).then(mapResponseBody);
      },
      requestNewOTPForSignupFlow(email) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/signup/otp/resend-verification',
          data: {
            email
          }
        }).then(mapResponseBody);
      },
      validateOTP(email, otp, utms) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/login/otp',
          data: {
            email,
            otp,
            utms
          },
          disableSentry: err => err.hasStatus([400, 429])
        }).then(res => res.data.authToken);
      },
      validateOTPForSignupFlow(email, otp, utms) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/signup/otp/verify',
          data: {
            email,
            otp,
            utms
          },
          disableSentry: err => err.hasStatus([400])
        }).then(res => res.data.authToken);
      }
    },
    video: {
      markVideoAsWatched(id) {
        return sendRequest({
          method: 'post',
          url: "/users/videos/".concat(id, "/watched"),
          apiHost: APIHost.Scout
        }).then(mapResponseBody);
      }
    },
    user: {
      switchBusiness(businessId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/user/me/switch-workspace',
          allowedForAccountants: true,
          data: {
            businessId
          }
        }).then(res => res.data.authToken);
      },
      // deprecated - endpoint no longer exists - this needs to be removed [ANC-7170]
      createNewClientBusiness(businessName) {
        return sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: '/business/customer',
          data: {
            name: businessName,
            accountsPayable: true,
            accountsReceivable: false
          }
        }).then(mapResponseBody);
      },
      getUserClientData() {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/client-data/user"
        }).then(mapResponseBody);
      },
      async setUserClientData(data) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/client-data/user",
          data
        });
      },
      getBusinessClientData() {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/client-data/business"
        }).then(mapResponseBody);
      },
      async setBusinessClientData(data) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/client-data/business",
          data
        });
      },
      referral() {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/user/referral',
          urlForSentry: '/user/referral'
        }).then(mapResponseBody).then(ReferralModel.fromDTO);
      },
      updateBranding(businessId, branding) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/".concat(businessId, "/branding"),
          urlForSentry: '/business/:id/branding',
          data: branding
        }).then(mapResponseBody);
      },
      changeUserEmail(_ref8) {
        let {
          email
        } = _ref8;
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/user/change-email/otp",
          data: {
            email
          },
          allowedForAccountants: true,
          disableSentry: err => err.hasServerError([ServerError.EmailAlreadyRegistered]) || err.isTooManyAttemptsError()
        }).then(mapResponseBody);
      },
      verifyEmailWithOTP(_ref9) {
        let {
          otp,
          email
        } = _ref9;
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/user/change-email/verify",
          allowedForAccountants: true,
          data: {
            email,
            otp
          },
          disableSentry: err => err.hasServerError([ServerError.EmailAlreadyRegistered, ServerError.InvalidOTP]) || err.isTooManyAttemptsError()
        }).then(mapResponseBody);
      },
      getOTPCode() {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/user/generic-otp/send",
          allowedForAccountants: true,
          disableSentry: err => err.isTooManyAttemptsError()
        }).then(mapResponseBody);
      },
      verifyOTP(_ref10) {
        let {
          otp
        } = _ref10;
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/user/generic-otp/verify",
          allowedForAccountants: true,
          data: {
            otp
          },
          disableSentry: err => err.hasServerError([ServerError.InvalidOTP]) || err.isTooManyAttemptsError()
        }).then(mapResponseBody);
      },
      getTeamInvites() {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/user/team-invites'
        }).then(mapResponseBody).then(res => res.invites.map(TeamInviteModel.fromDTO));
      },
      updateBuyer(userId, data) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/user/".concat(userId, "/update-buyer"),
          data
        }).then(mapResponseBody);
      },
      updateBuyerEmail(userId, email, customerBusinessId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/user/".concat(userId, "/update-buyer-email"),
          data: {
            email,
            customerBusinessId
          }
        }).then(mapResponseBody);
      }
    },
    vendor: {
      async create(data) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/business/vendor',
          data,
          disableSentry: err => err.isStripeError()
        });
        return res.data;
      },
      async update(data) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/business/vendor/update',
          data,
          disableSentry: err => err.isStripeError()
        });
        return res.data;
      },
      async authorizeVendorBankAccount(_ref11) {
        let {
          routingNumber,
          accountNumber
        } = _ref11;
        await sendRequest({
          apiHost: APIHost.Plaid,
          method: 'post',
          url: '/direct/authorize-account',
          urlForSentry: '/direct/authorize-account',
          data: {
            routingNumber,
            accountNumber
          }
        });
      },
      async updateBusinessDetails(businessId, data) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/".concat(businessId, "/details"),
          urlForSentry: '/business/:id/details',
          data
        });
      },
      async updateBusinessSettings(businessId, data) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/".concat(businessId, "/settings"),
          urlForSentry: '/business/:id/settings',
          data
        });
      },
      async getBusinessSettings(businessId) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/business/".concat(businessId, "/settings"),
          urlForSentry: '/business/:id/settings'
        });
        return BusinessSettingsModel.fromDTO(res.data);
      },
      getStripeHostedKYBUrl(businessId) {
        return sendRequest({
          apiHost: APIHost.KYB,
          method: 'get',
          url: "/business/".concat(businessId, "/stripe-hosted-kyb"),
          urlForSentry: '/business/:id/stripe-hosted-kyb'
        }).then(mapResponseBody);
      },
      getKYBInquiry(businessId) {
        return sendRequest({
          apiHost: APIHost.KYB,
          method: 'get',
          url: "/business/".concat(businessId, "/inquiry"),
          urlForSentry: '/business/:id/inquiry'
        }).then(mapResponseBody);
      },
      getKYBInquiryWithSelfie(businessId) {
        return sendRequest({
          apiHost: APIHost.KYB,
          method: 'get',
          url: "/business/".concat(businessId, "/inquiry-with-selfie"),
          urlForSentry: '/business/:id/inquiry-with-selfie'
        }).then(mapResponseBody);
      },
      async getKYBStatus(businessId) {
        const res = await sendRequest({
          apiHost: APIHost.KYB,
          method: 'get',
          url: "/business/".concat(businessId, "/kyb-status"),
          urlForSentry: '/business/:id/kyb-status'
        });
        return res.data;
      },
      getTaxInfo(businessId) {
        return sendRequest({
          apiHost: APIHost.KYB,
          method: 'get',
          url: "/business/".concat(businessId, "/tax-info"),
          urlForSentry: '/business/:id/tax-info'
        }).then(mapResponseBody);
      }
    },
    ofacScreening: {
      async createInquiry(data) {
        const res = await sendRequest({
          apiHost: APIHost.KYB,
          method: 'post',
          url: '/ofac-screening-inquiry',
          data
        });
        return res.data;
      },
      async getUserStatus(userId) {
        const res = await sendRequest({
          apiHost: APIHost.KYB,
          method: 'get',
          url: "/user/".concat(userId, "/ofac-screening-status"),
          urlForSentry: '/user/:id/ofac-screening-status'
        });
        return new LatestOFACSanctionStatusModel(res.data);
      },
      async getBusinessStatus(businessId) {
        const res = await sendRequest({
          apiHost: APIHost.KYB,
          method: 'get',
          url: "/business/".concat(businessId, "/ofac-screening-status"),
          urlForSentry: '/business/:id/ofac-screening-status'
        });
        return new LatestOFACSanctionStatusModel(res.data);
      }
    },
    zapier: {
      getApiKey() {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/integrations/zapier/api-key',
          urlForSentry: '/integrations/zapier/api-key',
          allowedForAccountants: true
        }).then(res => res.data.apiKey);
      }
    },
    make: {
      getApiKey() {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/business/api-keys?platform=make',
          urlForSentry: '/business/api-keys?platform=make',
          allowedForAccountants: true
        }).then(res => res.data.apiKey);
      }
    },
    monday: {
      getApiKey() {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/business/api-keys?platform=monday',
          urlForSentry: '/business/api-keys?platform=monday',
          allowedForAccountants: true
        }).then(res => res.data.apiKey);
      }
    },
    member: {
      async getAll(businessId) {
        const bid = businessId || selectors.user.businessId(getState());
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/business/".concat(bid, "/member"),
          urlForSentry: '/business/:id/member'
        });
        return {
          members: res.data.members.map(m => new MemberModel(m)),
          accountants: res.data.accountants.map(m => new AccountantModel(m))
        };
      },
      async invite(data) {
        const businessId = selectors.user.businessId(getState());
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/".concat(businessId, "/member/invite"),
          urlForSentry: '/business/:id/member/invite',
          data,
          disableSentry: err => err.hasServerError([ServerError.UserAlreadyInBusiness, ServerError.UserAlreadyAffiliatedWithBusiness, ServerError.PendingInvitationAlreadyExists])
        });
      },
      async resendInvitation(businessId, invitedUserId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/".concat(businessId, "/member/resend-invitation"),
          urlForSentry: '/business/:id/member/resend-invitation',
          data: {
            invitedUserId
          },
          disableSentry: err => err.hasServerError([ServerError.InvalidTeamInvitation])
        });
      },
      async changeRole(data) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/member/change-role",
          data
        });
      },
      async remove(data) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/business/member/deactivate',
          data
        });
      },
      getAssignedRelationships(memberId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/relationship/count/user/".concat(memberId)
        }).then(res => res.data.count);
      },
      async reassignAllRelationships(data) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/relationship/reassign/all',
          data
        });
      }
    },
    activityLog: {
      async get(relationshipId) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/relationship/".concat(relationshipId, "/activity-log"),
          urlForSentry: '/relationship/:id/activity-log'
        });
        return res.data.logs.map(ActivityLogEntryModel.make);
      }
    },
    invoice: {
      async void(invoiceId) {
        await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/invoice/".concat(invoiceId, "/void"),
          urlForSentry: '/invoice/:id/void'
        });
      },
      async unvoid(invoiceId) {
        await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/invoice/".concat(invoiceId, "/unvoid"),
          urlForSentry: '/invoice/:id/unvoid',
          disableSentry: err => err.hasServerError([ServerError.InvoiceNotVoided])
        });
      },
      async unmarkAsPaidExternally(invoiceId) {
        await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/invoice/".concat(invoiceId, "/unmark-paid-externally"),
          urlForSentry: '/invoice/:id/unmark-paid-externally',
          disableSentry: err => err.hasServerError(ServerError.InvoiceNotPaidExternally)
        });
      },
      getByID(invoiceId, isCustomer) {
        return sendRequest({
          apiHost: APIHost.Scout,
          method: 'get',
          url: "/invoice/".concat(invoiceId),
          urlForSentry: '/invoice/:id',
          params: {
            view: isCustomer ? 'customer' : 'vendor'
          }
        }).then(res => invoiceModel.fromDTO(!isCustomer, res.data));
      },
      downloadPDF(invoiceId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/invoice/".concat(invoiceId, "/pdf"),
          urlForSentry: '/invoice/:id/pdf'
        }).then(res => res.data.url);
      },
      async resend(invoiceId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/invoice/".concat(invoiceId, "/resend"),
          urlForSentry: '/invoice/:id/resend'
        });
      },
      async retryCharge(invoiceId) {
        await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/invoice/".concat(invoiceId, "/retry-payment"),
          urlForSentry: '/invoice/:id/retry-payment'
        });
      },
      async markAsPaidExternally(invoiceId) {
        await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/invoice/".concat(invoiceId, "/paid-externally"),
          urlForSentry: '/invoice/:id/paid-externally',
          disableSentry: err => err.hasServerError(ServerError.IncorrectStatusForPaidExternally)
        });
      },
      async approve(invoiceId) {
        const isCustomer = selectors.user.isClient(getState());
        if (!isCustomer) throw new Error('only clients can approve invoice');
        await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/invoice/".concat(invoiceId, "/approve"),
          urlForSentry: '/invoice/:id/approve',
          params: {
            isCustomer
          }
        });
      },
      async getAll() {
        let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const {
          relationshipId,
          sort,
          search,
          status,
          paymentStatus,
          issuedOnSince,
          issuedOnUntil,
          integration,
          xeroIntegration,
          pageSize,
          pageNumber
        } = filters;
        const isVendor = selectors.user.isVendor(getState());
        const serializeArray = arr => arr && arr.length > 0 ? arr.join(',') : undefined;
        const serializeDate = date => date ? format(date, 'yyyy-MM-dd') : undefined;
        const res = await sendRequest({
          method: 'get',
          apiHost: APIHost.Scout,
          url: '/invoices-summary-with-counters',
          params: {
            view: isVendor ? 'vendor' : 'customer',
            relationship: relationshipId,
            sort: sort ? "".concat(sort.field, ",").concat(sort.type) : undefined,
            pageSize,
            pageNumber,
            search: search || undefined,
            status: serializeArray(status),
            paymentStatus: serializeArray(paymentStatus),
            issuedOnSince: serializeDate(issuedOnSince),
            issuedOnUntil: serializeDate(issuedOnUntil),
            integration: integration === AccountingStatusFilter.Synced ? InvoiceAccountingSyncStatusFilter.Synced : filters.integration === AccountingStatusFilter.NotSynced ? InvoiceAccountingSyncStatusFilter.Unsynced : undefined,
            xeroIntegration: xeroIntegration === AccountingStatusFilter.Synced ? InvoiceAccountingSyncStatusFilter.Synced : filters.xeroIntegration === AccountingStatusFilter.NotSynced ? InvoiceAccountingSyncStatusFilter.Unsynced : undefined
          }
        });
        return {
          invoices: res.data.invoices.map(inv => invoiceModel.fromDTO(isVendor, inv)),
          total: res.data.total,
          statusFilterCounters: res.data.statusFilterCounters,
          paymentStatusFilterCounters: res.data.paymentStatusFilterCounters,
          qboStatusFilterCounters: res.data.qboStatusFilterCounters,
          xeroStatusFilterCounters: res.data.xeroStatusFilterCounters
        };
      },
      async exportToCsv() {
        let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const {
          sort,
          search,
          status,
          paymentStatus,
          issuedOnSince,
          issuedOnUntil,
          integration
        } = filters;
        const serializeArray = arr => arr && arr.length > 0 ? arr.join(',') : undefined;
        const serializeDate = date => date ? format(date, 'yyyy-MM-dd') : undefined;
        const res = await sendRequest({
          method: 'get',
          apiHost: APIHost.Scout,
          url: '/invoices-csv',
          params: {
            sort: sort ? "".concat(sort.field, ",").concat(sort.type) : undefined,
            search: search || undefined,
            status: serializeArray(status),
            paymentStatus: serializeArray(paymentStatus),
            issuedOnSince: serializeDate(issuedOnSince),
            issuedOnUntil: serializeDate(issuedOnUntil),
            integration: integration === AccountingStatusFilter.Synced ? InvoiceAccountingSyncStatusFilter.Synced : filters.integration === AccountingStatusFilter.NotSynced ? InvoiceAccountingSyncStatusFilter.Unsynced : undefined
          }
        });
        return res.data;
      },
      async stopPayment(invoiceId, reason) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/invoice/".concat(invoiceId, "/stop-payment"),
          data: {
            reason
          }
        });
      },
      async resumePayment(invoiceId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/invoice/".concat(invoiceId, "/resume-payment")
        });
      },
      async refundPayment(invoiceId, reason) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/invoice/".concat(invoiceId, "/refund-payment"),
          data: {
            reason
          }
        });
      },
      async refundPartialPayment(invoiceId, data) {
        await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/invoice/".concat(invoiceId, "/refund"),
          data
        });
      },
      async refundPartialPaymentV2(invoiceId, data) {
        await sendRequest({
          method: 'post',
          apiHost: APIHost.Mgmt,
          url: "/invoice/".concat(invoiceId, "/refundV2"),
          data
        });
      },
      async calculateRefund(invoiceId, params) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/invoice/".concat(invoiceId, "/calculate-refund"),
          params,
          disableSentry: err => err.hasServerError([ServerError.InvoiceRefundAmountExceeds, ServerError.InvoiceAlreadyHasOneRefundNotRefunded])
        }).then(mapResponseBody);
      },
      async payNow(invoiceId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/invoice/".concat(invoiceId, "/pay-now")
        });
      },
      async attachFiles(invoiceId, attachments) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/invoice/".concat(invoiceId, "/attach"),
          urlForSentry: '/invoice/:id/attach',
          data: {
            attachments
          }
        });
      },
      async getAttachmentDownloadUrl(invoiceId, attachmentId) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/invoice/".concat(invoiceId, "/attachments/").concat(attachmentId, "/download"),
          urlForSentry: '/invoice/:id/attachments/:attachmentId/download'
        });
        return res.data.url;
      },
      async removeAttachment(invoiceId, attachmentId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'delete',
          url: "/invoice/".concat(invoiceId, "/attachments/").concat(attachmentId),
          urlForSentry: '/invoice/:id/attachments/:attachmentId'
        });
      },
      disableAutoApprove(invoiceID) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          urlForSentry: '/invoice/:id/auto-approve/disable',
          method: 'post',
          url: "/invoice/".concat(invoiceID, "/auto-approve/disable")
        }).then(mapResponseBody);
      },
      getDigestFromQuery() {
        const businessId = selectors.user.businessId(getState());
        return sendRequest({
          apiHost: APIHost.Scout,
          method: 'get',
          url: "/invoices/vendor/".concat(businessId, "/payment-status-counts"),
          urlForSentry: "/invoices/vendor/:id/payment-status-counts"
        }).then(response => InvoicesDigestModel.fromOptimizedQueryDTO(response.data));
      },
      approveInvoiceFromEmail(_ref12) {
        let {
          approvalToken
        } = _ref12;
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/invoice/approve-by-token",
          data: {
            approvalToken
          },
          disableSentry: err => err.hasServerError([ServerError.InvoiceAlreadyApproved, ServerError.InvoiceWasVoided, ServerError.InvalidRelationshipStatus])
        }).then(mapResponseBody);
      },
      resyncQbo(invoiceId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/accounting/qbo/invoices/".concat(invoiceId, "/resync"),
          urlForSentry: "/integrations/accounting/qbo/invoices/:id/resync"
        }).then(mapResponseBody);
      },
      resyncXero(invoiceId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/accounting/xero/invoices/".concat(invoiceId, "/resync"),
          urlForSentry: "/integrations/accounting/xero/invoices/:id/resync"
        }).then(mapResponseBody);
      },
      getResyncXeroStatus(invoiceId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/integrations/accounting/xero/invoices/".concat(invoiceId, "/resync-status"),
          urlForSentry: "/integrations/accounting/xero/invoices/:invoiceId/resync-status"
        }).then(mapResponseBody);
      },
      getResyncQboStatus(invoiceId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/integrations/accounting/qbo/invoices/".concat(invoiceId, "/resync-status"),
          urlForSentry: "/integrations/accounting/qbo/invoices/:invoiceId/resync-status"
        }).then(mapResponseBody);
      }
    },
    serviceTemplate: {
      getAll(businessId, _ref13) {
        let {
          includeDeleted,
          includeAdhocCharges,
          invoiceId,
          type
        } = _ref13;
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/business/".concat(businessId, "/service-template"),
          urlForSentry: "/business/:id/service-template",
          params: {
            includeDeleted,
            includeAdhocCharges,
            invoiceId,
            type: type.join(',')
          }
        }).then(res => {
          const {
            services
          } = res.data;
          const raw = services.map(serviceTemplateModel.fromDTO);
          const active = [];
          const deleted = [];
          raw.forEach(s => {
            if (serviceTemplateModel.isDeleted(s)) {
              deleted.push(s);
            } else {
              active.push(s);
            }
          });
          return {
            active,
            deleted,
            raw
          };
        });
      },
      getById(businessId, serviceTemplateId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/business/".concat(businessId, "/service-template/").concat(serviceTemplateId),
          urlForSentry: '/business/:id/service-template/:serviceId'
        }).then(res => serviceTemplateModel.fromDTO(res.data));
      },
      create(serviceTemplate, businessId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/v2/business/".concat(businessId, "/service-template/create"),
          urlForSentry: 'v2/business/:id/service-template/create',
          data: serviceTemplateModel.toDTO(serviceTemplate),
          disableSentry: err => err.hasServerError(ServerError.ServiceTemplateAlreadyExists)
        }).then(mapResponseBody);
      },
      update(serviceTemplate, businessId, descriptionObj) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/v2/business/".concat(businessId, "/service-template/update"),
          urlForSentry: '/v2/business/:id/service-template/update',
          data: _objectSpread(_objectSpread({}, serviceTemplateModel.toDTO(serviceTemplate)), descriptionObj && {
            descriptionObj
          }),
          disableSentry: err => err.hasServerError(ServerError.ServiceTemplateAlreadyExists)
        }).then(() => {});
      },
      async delete(id, businessId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/".concat(businessId, "/service-template/delete"),
          urlForSentry: "/business/:id/service-template/delete",
          data: {
            id
          }
        });
      }
    },
    integration: {
      async getAll() {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/integrations/list',
          params: {
            lightweight: false
          }
        });
        return res.data.map(integrationModel.fromDTO);
      },
      async getSummary() {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/integrations/list',
          params: {
            lightweight: true
          }
        });
        return res.data.map(integrationModel.fromDTO);
      }
    },
    accounting: {
      async connect(_ref14) {
        let {
          redirectUrl,
          accounting
        } = _ref14;
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/accounting/".concat(accounting, "/connect"),
          data: {
            redirectUrl
          }
        });
        return res.data.linkUrl;
      },
      disconnect(_ref15) {
        let {
          accounting
        } = _ref15;
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/accounting/".concat(accounting, "/disconnect")
        }).then(mapResponseBody);
      },
      getAccounts(_ref16) {
        let {
          accounting
        } = _ref16;
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/integrations/accounting/".concat(accounting, "/accounts")
        }).then(mapResponseBody);
      },
      getCustomers(_ref17) {
        let {
          accounting
        } = _ref17;
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/integrations/accounting/".concat(accounting, "/customers")
        }).then(res => res.data.customers.map(AccountingCustomerModel.fromDTO));
      },
      getItems(_ref18) {
        let {
          accounting,
          type
        } = _ref18;
        return sendRequest({
          method: 'get',
          apiHost: APIHost.Mgmt,
          url: "/integrations/accounting/".concat(accounting, "/items?type=").concat(type.join(','))
        }).then(res => _objectSpread(_objectSpread({}, res.data), {}, {
          items: res.data.items.map(item => {
            var _item$type;
            return _objectSpread(_objectSpread({}, item), {}, {
              type: (_item$type = item.type) !== null && _item$type !== void 0 ? _item$type : AccountingItemType.Service
            });
          })
        }));
      },
      async linkAccount(_ref19) {
        let {
          data,
          accounting
        } = _ref19;
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/accounting/".concat(accounting, "/link-account"),
          data
        });
      },
      async linkServiceTemplate(_ref20) {
        let {
          serviceTemplateId,
          integratedId,
          accounting,
          type
        } = _ref20;
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/accounting/".concat(accounting, "/service-templates/").concat(serviceTemplateId, "/link"),
          urlForSentry: "/integrations/accounting/:id/service-templates/:id/link",
          data: {
            integratedId,
            type
          }
        });
      },
      async createContact(_ref21) {
        let {
          contactId,
          accounting
        } = _ref21;
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/accounting/".concat(accounting, "/clients/").concat(contactId, "/create"),
          urlForSentry: "/integrations/accounting/".concat(accounting, "/clients/:id/create"),
          disableSentry: err => err.hasServerError(ServerError.DuplicateNameExists)
        }).then(mapResponseBody);
      },
      async linkContact(_ref22) {
        let {
          contactId,
          data,
          accounting
        } = _ref22;
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/accounting/".concat(accounting, "/clients/").concat(contactId, "/link"),
          urlForSentry: "/integrations/accounting/".concat(accounting, "/clients/:id/link"),
          data
        });
      },
      async syncInvoice(accounting, invoiceId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/accounting/".concat(accounting, "/invoices/").concat(invoiceId),
          urlForSentry: "/integrations/accounting/".concat(accounting, "/invoices/:id")
        });
      },
      async retrySyncInvoice(accounting, invoiceId, includeTimeActivities) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/accounting/".concat(accounting, "/invoices/").concat(invoiceId, "/retry"),
          urlForSentry: "/integrations/accounting/".concat(accounting, "/invoices/:id/retry"),
          data: {
            includeTimeActivities
          }
        });
      },
      async syncRefund(accounting, invoiceId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/accounting/".concat(accounting, "/invoices/").concat(invoiceId, "/refund"),
          urlForSentry: "/integrations/accounting/".concat(accounting, "/invoices/:id/refund")
        });
      },
      async syncPayment(_ref23) {
        let {
          invoiceId,
          accounting
        } = _ref23;
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/accounting/".concat(accounting, "/invoices/").concat(invoiceId, "/payment"),
          urlForSentry: "/integrations/accounting/".concat(accounting, "/invoices/:id/payment")
        });
      },
      async syncPayout(_ref24) {
        let {
          payoutId,
          accounting
        } = _ref24;
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/accounting/".concat(accounting, "/payouts/").concat(payoutId)
        });
      },
      async updateSettings(_ref25) {
        let {
          accounting,
          settings
        } = _ref25;
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/accounting/".concat(accounting, "/update"),
          data: settings
        });
      }
    },
    qbo: {
      async getClasses() {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/integrations/accounting/qbo/classes"
        });
        return res.data.classes;
      },
      async getTimeActivities(relationshipId) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/integrations/accounting/qbo/relationships/".concat(relationshipId, "/time-activities"),
          urlForSentry: '/integrations/accounting/qbo/relationships/:id/time-activities'
        });
        return TimeActivitiesModel.fromDTO(res.data.services);
      }
    },
    practiceManagement: {
      async getMatchingCompanies(pmName, relationshipId) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/integrations/".concat(pmName, "/relationships/").concat(relationshipId, "/matched-contacts-companies"),
          urlForSentry: "/integrations/".concat(pmName, "/relationships/:relationshipId/matched-contacts-companies")
        });
        return res.data.companies || [];
      },
      async linkContact(pmName, relationshipId, companyId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/".concat(pmName, "/relationships/").concat(relationshipId, "/link-contact"),
          urlForSentry: "/integrations/".concat(pmName, "/relationships/:id/link-contact"),
          data: {
            companyId: companyId
          }
        }).then(mapResponseBody);
      },
      async createNewCompanyAndContact(pmName, relationshipId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/".concat(pmName, "/relationships/").concat(relationshipId, "/create-client"),
          urlForSentry: "/integrations/".concat(pmName, "/relationships/:id/create-client")
        }).then(mapResponseBody);
      },
      async dismissSyncFailure(pmName, relationshipId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/".concat(pmName, "/relationships/").concat(relationshipId, "/dismiss-failure"),
          urlForSentry: "/integrations/".concat(pmName, "/relationships/:id/dismiss-failure")
        }).then(mapResponseBody);
      }
    },
    financialCents: {
      async connect(redirectUrl) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/integrations/financial-cents',
          data: {
            type: 'oauth',
            oauth: {
              redirectUrl
            }
          }
        });
        return res.data.oauth.linkUrl;
      },
      async disconnect() {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/integrations/financial-cents/disconnect'
        });
      },
      async getItems() {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/integrations/financial-cents/items'
        });
        return res.data.status === IntegrationResponseStatus.Success ? res.data.items : [];
      },
      async linkServiceTemplate(serviceTemplateId, integratedIds) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/integrations/financial-cents/items/link',
          data: {
            id: serviceTemplateId,
            integratedIds
          }
        });
      },
      async getUsers() {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/integrations/financial-cents/users'
        });
        return res.data.status === IntegrationResponseStatus.Success ? res.data.users || [] : [];
      },
      async getRoles(serviceTemplateId) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/integrations/financial-cents/".concat(serviceTemplateId, "/roles")
        });
        return res.data.status === IntegrationResponseStatus.Success ? res.data.roles || [] : [];
      }
    },
    serviceInvoices: {
      getByBusinessId(businessId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/serviceBilling/".concat(businessId),
          urlForSentry: '/serviceBilling/:businessId'
        }).then(res => (res.data.Entries || []).map(ServiceInvoiceModel.fromDTO));
      },
      getCredit() {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/business/payments-credit'
        }).then(res => utils.centsToDollars(res.data.amount));
      },
      getDownloadURL(filename) {
        const businessId = selectors.user.businessId(getState());
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/business/".concat(businessId, "/file/").concat(filename),
          urlForSentry: '/business/:id/file/:id'
        }).then(mapResponseBody);
      }
    },
    paymentMethod: {
      /**
       * Fetches the payment methods for a given agreement
       * When the vendor sends the request he will get an empty array.
       */
      clientGet(vendorId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/payment-method/vendor/".concat(vendorId),
          urlForSentry: '/payment-method/vendor/:id'
        }).then(res => res.data.paymentMethods);
      },
      /**
       * Fetches the payment methods for a given agreement
       * When the client sends the request he will get an empty array.
       */
      vendorGet(customerId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/payment-method/customer/".concat(customerId),
          urlForSentry: '/payment-method/customer/:id'
        }).then(res => res.data.paymentMethods);
      },
      clientAddToBusiness(paymentMethodId, vendorId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/payment-method/".concat(paymentMethodId, "/vendor/").concat(vendorId),
          urlForSentry: '/payment-method/:id/vendor/:id',
          allowedForAccountants: true
        }).then(res => res.data.details);
      },
      vendorAddToBusiness(paymentMethodId, customerId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/payment-method/".concat(paymentMethodId, "/customer/").concat(customerId),
          urlForSentry: '/payment-method/:id/customer/:id'
        }).then(res => res.data.details);
      },
      async delete(fundingSourceId, vendorId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/payment-method/funding-source/".concat(fundingSourceId, "/delete"),
          urlForSentry: '/payment-method/funding-source/delete',
          allowedForAccountants: true,
          data: {
            vendorId
          }
        });
      },
      async clientDelete(fundingSourceId, vendorId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/payment-method/funding-source/".concat(fundingSourceId, "/by-customer/delete"),
          urlForSentry: '/payment-method/funding-source/:id/by-customer/delete',
          allowedForAccountants: true,
          data: {
            vendorId
          }
        });
      },
      async vendorDelete(fundingSourceId, customerId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/payment-method/funding-source/".concat(fundingSourceId, "/by-vendor/delete"),
          urlForSentry: '/payment-method/funding-source/:id/by-vendor/delete',
          allowedForAccountants: true,
          data: {
            customerId
          }
        });
      },
      createSetupIntent(vendorId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/payment-method/".concat(vendorId, "/create-payment-intent"),
          urlForSentry: '/payment-method/:vendorId/create-payment-intent',
          allowedForAccountants: true
        }).then(mapResponseBody);
      },
      clientCreateSetupIntent(vendorId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/payment-method/vendor/".concat(vendorId, "/create-payment-intent"),
          urlForSentry: '/payment-method/vendor/:vendorId/create-payment-intent',
          allowedForAccountants: true
        }).then(mapResponseBody);
      },
      vendorCreateSetupIntent(customerId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/payment-method/customer/".concat(customerId, "/create-payment-intent"),
          urlForSentry: '/payment-method/customer/:customerId/create-payment-intent'
        }).then(mapResponseBody);
      }
    },
    business: {
      getLegalTerms() {
        const businessId = selectors.user.businessId(getState());
        if (!businessId) throw new Error('no business ID');
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/business/".concat(businessId, "/legal-terms"),
          urlForSentry: '/business/:id/legal-terms'
        }).then(mapResponseBody);
      },
      async removeLegalTerms(legalTermsId) {
        const businessId = selectors.user.businessId(getState());
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/".concat(businessId, "/legal-terms/delete"),
          urlForSentry: '/business/:id/legal-terms/delete',
          data: {
            id: legalTermsId
          }
        });
      },
      async renameLegalTerms(legalTermsId, newName) {
        const businessId = selectors.user.businessId(getState());
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/".concat(businessId, "/legal-terms/rename"),
          urlForSentry: '/business/:id/legal-terms/rename',
          data: {
            id: legalTermsId,
            name: newName
          }
        }).then(mapResponseBody);
      },
      createLegalTermsOld(data) {
        const businessId = selectors.user.businessId(getState());
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/".concat(businessId, "/legal-terms/create"),
          urlForSentry: '/business/:id/legal-terms/create',
          data
        }).then(mapResponseBody);
      },
      createLegalTerms(data) {
        const businessId = selectors.user.businessId(getState());
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/v2/business/".concat(businessId, "/legal-terms/create"),
          urlForSentry: '/v2/business/:id/legal-terms/create',
          data
        }).then(mapResponseBody);
      },
      getLegalTermsUploadURL() {
        const businessId = selectors.user.businessId(getState());
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/business/".concat(businessId, "/legal-terms/upload-url"),
          urlForSentry: '/business/:id/legal-terms/upload-url'
        }).then(mapResponseBody);
      },
      getLegalTermsDownloadURL(filename, businessId) {
        const actualBusinessId = businessId || selectors.user.businessId(getState());
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/business/".concat(actualBusinessId, "/legal-terms/download-url"),
          urlForSentry: '/business/:id/legal-terms/download-url',
          params: {
            filename
          }
        }).then(res => res.data.url);
      },
      getLogoUploadURL() {
        const businessId = selectors.user.businessId(getState());
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/business/".concat(businessId, "/logo/upload-url"),
          urlForSentry: '/business/:id/logo/upload-url'
        }).then(res => res.data.url);
      },
      getUploadUrls(filesData) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/upload-urls",
          urlForSentry: '/business/upload-urls',
          data: {
            filesData
          }
        }).then(mapResponseBody);
      },
      getInfo(businessId) {
        return sendRequest({
          method: 'get',
          url: "/businesses/".concat(businessId),
          urlForSentry: '/businesses/:id',
          apiHost: APIHost.Scout
        }).then(mapResponseBody);
      },
      updateBusinessOnboardingWidgetState(businessId, onboardingWidgetState) {
        return sendRequest({
          method: 'post',
          url: "/businesses/".concat(businessId, "/onboarding-state"),
          urlForSentry: '/businesses/:id/onboarding-state',
          apiHost: APIHost.Scout,
          data: {
            onboardingWidgetState
          }
        }).then(mapResponseBody);
      },
      async acceptTeamInvite(_ref26) {
        let {
          invitationId,
          businessId
        } = _ref26;
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/".concat(businessId, "/member/accept-invite"),
          data: {
            invitationId
          },
          urlForSentry: "/business/:businessId/member/accept-invite",
          disableSentry: err => err.hasServerError([ServerError.InvalidTeamInvitation])
        });
      },
      async getAPIKeys(params) {
        return sendRequest({
          apiHost: APIHost.External,
          method: 'get',
          url: '/business/api-keys',
          urlForSentry: '/business/api-keys',
          params: {
            sortField: params === null || params === void 0 ? void 0 : params.sortBy,
            sortDirection: params === null || params === void 0 ? void 0 : params.sortDirection
          }
        }).then(mapResponseBody);
      },
      async createAPIKey(name) {
        return sendRequest({
          apiHost: APIHost.External,
          method: 'post',
          url: '/business/api-key',
          data: {
            name
          },
          urlForSentry: '/business/api-key'
        }).then(mapResponseBody);
      },
      async regenerateAPIKey(id) {
        return sendRequest({
          apiHost: APIHost.External,
          method: 'post',
          url: "/business/api-key/regenerate",
          urlForSentry: '/business/api-key/regenerate',
          data: {
            id
          }
        }).then(mapResponseBody);
      },
      async renameAPIKey(_ref27) {
        let {
          id,
          newName
        } = _ref27;
        await sendRequest({
          apiHost: APIHost.External,
          method: 'post',
          url: "/business/api-key/rename",
          urlForSentry: '/business/api-key/rename',
          data: {
            id,
            newName
          },
          disableSentry: e => e.hasServerError([ServerError.APIKeyNotFound, ServerError.APIKeyRenameFailed])
        });
      },
      async deactivateAPIKey(id) {
        await sendRequest({
          apiHost: APIHost.External,
          method: 'post',
          url: "/business/api-key/deactivate",
          urlForSentry: '/business/api-keys/deactivate',
          data: {
            id
          }
        });
      },
      updateBuyerCompany(customerBusinessId, companyName) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/".concat(customerBusinessId, "/update-client"),
          data: {
            companyName
          }
        }).then(mapResponseBody);
      },
      async getActivityLogs() {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/business/activity-log",
          urlForSentry: '/business/activity-log',
          disableSentry: err => err.hasServerError([ServerError.ClientNotOwnedByVendor, ServerError.MultiVendorCustomerNotEditable])
        });
        return res.data.logs.map(ActivityLogEntryModel.make);
      }
    },
    invoiceDraft: {
      getDates(relationshipId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/billing/".concat(relationshipId, "/dates"),
          urlForSentry: '/billing/:id/dates'
        }).then(res => InvoiceDraftDatesModel.fromDTO(res.data));
      },
      getByDate(relationshipId, date) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/billing/".concat(relationshipId, "/invoice-draft"),
          urlForSentry: '/billing/:id/invoice-draft',
          params: {
            issueDate: timeModel.toDatestampArray(date).join(',')
          }
        }).then(res => res.data && invoiceDraftModel.fromDTO(res.data));
      },
      getForAmendedService(relationshipId, service) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/relationship/".concat(relationshipId, "/amended-item-draft"),
          urlForSentry: '/relationship/:id/amended-item-draft',
          data: serviceModel.toDTO(service)
        }).then(res => ({
          issueDate: fromDateStampObject(res.data.issueDate),
          lineItem: invoiceDraftModel.lineItemFromDTO(res.data.lineItem)
        }));
      }
    },
    notification: {
      emailOnBehalf: {
        async connectEmailOnBehalf(_ref28) {
          let {
            businessId,
            provider,
            pageUrl
          } = _ref28;
          return sendRequest({
            apiHost: APIHost.Mgmt,
            method: 'post',
            url: "/business/".concat(businessId, "/settings/notifications/send-on-behalf-of/authorize-").concat(provider),
            urlForSentry: "/business/:businessId/settings/notifications/send-on-behalf-of/authorize-".concat(provider),
            config: {
              headers: {
                'anchor-return-to-path': pageUrl
              }
            }
          }).then(response => response.data.url);
        },
        async completeGmailAuthorization(_ref29) {
          let {
            businessId,
            code,
            scope,
            csrfToken,
            redirectUri
          } = _ref29;
          await sendRequest({
            apiHost: APIHost.Mgmt,
            method: 'post',
            url: "/business/".concat(businessId, "/settings/notifications/send-on-behalf-of/complete-gmail-authorization"),
            urlForSentry: "/business/:businessId/settings/notifications/send-on-behalf-of/complete-gmail-authorization",
            data: {
              authorizationCode: code,
              scope,
              csrfToken,
              redirectUri
            },
            disableSentry: err => err.hasServerError([ServerError.InvalidScopeMissingGmailSend])
          });
        },
        async completeOutlookAuthorization(_ref30) {
          let {
            businessId,
            code,
            csrfToken,
            redirectUri
          } = _ref30;
          await sendRequest({
            apiHost: APIHost.Mgmt,
            method: 'post',
            url: "/business/".concat(businessId, "/settings/notifications/send-on-behalf-of/complete-outlook-authorization"),
            urlForSentry: "/business/:businessId/settings/notifications/send-on-behalf-of/complete-outlook-authorization",
            data: {
              authorizationCode: code,
              csrfToken,
              redirectUri
            }
          });
        },
        async disconnectEmailOnBehalf(businessId) {
          await sendRequest({
            apiHost: APIHost.Mgmt,
            method: 'delete',
            url: "/business/".concat(businessId, "/settings/notifications/send-on-behalf-of"),
            urlForSentry: "/business/:businessId/settings/notifications/send-on-behalf-of"
          });
        }
      },
      async getWhileLoggedIn(notificationId, intent) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          params: {
            intent
          },
          url: "/notification/auth/".concat(notificationId),
          urlForSentry: '/notification/auth/:id',
          disable403Handling: true,
          disableSentry: err => err.status === 401 || err.hasServerError([ServerError.RecipientNotFound, ServerError.InvalidTeamInvitation])
        });
        return res.data;
      },
      async getWhileLoggedOut(notificationId, intent) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          params: {
            intent
          },
          url: "/notification/no-auth/".concat(notificationId),
          urlForSentry: '/notification/no-auth/:id',
          disableSentry: err => err.hasStatus([401]),
          disable403Handling: true
        });
        return res.data;
      },
      async getNotificationSettings(businessId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/business/".concat(businessId, "/settings/notifications"),
          urlForSentry: "/business/:businessId/settings/notifications"
        }).then(res => _objectSpread(_objectSpread({}, res.data), {}, {
          sendOnBehalfOf: EmailOnBehalfSettingsModel.fromDTO(res.data.sendOnBehalfOf)
        }));
      },
      async updateNotificationSettings(_ref31) {
        let {
          data,
          businessId,
          notificationName
        } = _ref31;
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/".concat(businessId, "/settings/notifications/").concat(notificationName),
          urlForSentry: "/business/:businessId/settings/notifications/:notificationType",
          data
        });
      }
    },
    inAppNotifications: {
      getAll() {
        return sendRequest({
          method: 'get',
          apiHost: APIHost.Mgmt,
          url: '/business/notifications-mailbox'
        }).then(mapResponseBody);
      },
      async markAsSeen(notificationItemIds) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/notifications-mailbox/mark-as-seen",
          data: {
            ids: notificationItemIds
          }
        });
      },
      async markAsRead(notificationItemId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/notifications-mailbox/mark-as-read",
          data: {
            id: notificationItemId
          }
        });
      }
    },
    accountants: {
      /** Request access as an accountant to the customer's business. */
      async requestAccess(customerId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/accountants/request-access/".concat(customerId),
          urlForSentry: '/business/accountants/request-access/:id'
        }).then(mapResponseBody);
      },
      /** Cancels an active request for access. */
      async cancelRequestAccess(customerId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/accountants/cancel-request-access/".concat(customerId),
          urlForSentry: '/business/accountants/cancel-request-access/:id'
        });
      },
      /** Removes access for the existing user as an accountant to the customer's business. */
      async removeMe(customerId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/accountants/remove-me/".concat(customerId),
          urlForSentry: '/business/accountants/remove-me/:id'
        });
      },
      async removeVendor(vendorId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/accountants/remove/".concat(vendorId),
          urlForSentry: '/business/accountants/remove/:id'
        });
      },
      async approveVendor(vendorId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/accountants/approve/".concat(vendorId),
          urlForSentry: '/business/accountants/approve/:id'
        });
      },
      async rejectVendor(vendorId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/business/accountants/reject/".concat(vendorId),
          urlForSentry: '/business/accountants/reject/:id'
        });
      }
    },
    payout: {
      getById(payoutId) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/v2/business/payouts/".concat(payoutId),
          urlForSentry: '/v2/business/payouts/:id'
        }).then(res => PayoutModel.fromDTO(res.data));
      },
      async getAll() {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/business/payouts',
          urlForSentry: '/business/payouts'
        });
        return {
          invoiceHeaders: res.data.InvoiceHeaders,
          payouts: res.data.Payouts.map(payout => PayoutModel.fromDTO(payout))
        };
      },
      async getAllFromScout() {
        let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const {
          qboIntegration,
          xeroIntegration,
          pageSize,
          pageNumber,
          sort,
          search
        } = filters;
        const res = await sendRequest({
          method: 'get',
          apiHost: APIHost.Scout,
          url: '/payouts',
          params: {
            sortField: sort === null || sort === void 0 ? void 0 : sort.field,
            sortDirection: sort === null || sort === void 0 ? void 0 : sort.type,
            pageSize,
            pageNumber,
            search,
            qboSyncStatus: qboIntegration,
            xeroSyncStatus: xeroIntegration
          }
        });
        return {
          payouts: res.data.payouts.map(payout => PayoutModel.fromScoutDTO(payout)),
          invoiceHeaders: res.data.invoiceHeaders,
          total: res.data.total,
          qboSyncStatusFilterCounters: res.data.qboSyncStatusFilterCounters,
          xeroSyncStatusFilterCounters: res.data.xeroSyncStatusFilterCounters
        };
      },
      async getSummary() {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/business/payouts-summary',
          params: {
            limit: 5,
            withFuturePayouts: 'true'
          }
        });
        return PayoutsSummaryModel.fromDTO(res.data);
      },
      async exportPayoutsToCsv() {
        let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const {
          qboIntegration,
          xeroIntegration,
          sort,
          search
        } = filters;
        const res = await sendRequest({
          method: 'get',
          apiHost: APIHost.Scout,
          url: '/payouts-csv',
          params: {
            sortField: sort === null || sort === void 0 ? void 0 : sort.field,
            sortDirection: sort === null || sort === void 0 ? void 0 : sort.type,
            search,
            qboSyncStatus: qboIntegration,
            xeroSyncStatus: xeroIntegration
          }
        });
        return res.data;
      }
    },
    report: {
      getMonthlyEarnings() {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/business/report/monthly-earnings'
        }).then(mapResponseBody);
      },
      async getHistoricAgreementStats(businessId) {
        const res = await sendRequest({
          apiHost: APIHost.Scout,
          method: 'get',
          url: "/businesses/".concat(businessId, "/historic-agreements-stats"),
          urlForSentry: '/businesses/:id/historic-agreements-stats'
        });
        return res.data.map(stats => new HistoricAgreementStatsModel(stats));
      },
      async getSalesSummary() {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/business/sales-summary'
        });
        return SalesSummaryModel.fromDTO(res.data, getNow());
      },
      async getHistoricPaidExternallyInvoices() {
        const res = await sendRequest({
          apiHost: APIHost.Scout,
          method: 'get',
          url: "/historic-paid-externally-invoices"
        });
        return res.data.map(HistoricRevenueModel.fromHistoricInvoiceDTO);
      },
      async getFutureInvoiceTotals(_ref32) {
        let {
          to
        } = _ref32;
        const res = await sendRequest({
          apiHost: APIHost.Scout,
          method: 'get',
          url: "/future-invoices/totals",
          params: {
            to
          }
        });
        return res.data.map(HistoricRevenueModel.fromHistoricInvoiceDTO);
      }
    },
    featureFlag: {
      getAll(businessId, authToken) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/feature-flags',
          params: {
            businessId
          },
          authToken
        }).then(mapResponseBody);
      }
    },
    plaid: {
      getLinkToken(mode) {
        let {
          fundingSourceId,
          relationshipId
        } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return sendRequest({
          apiHost: APIHost.Plaid,
          method: 'post',
          url: '/link-token',
          allowedForAccountants: true,
          data: {
            mode,
            fundingSourceId: fundingSourceId || null,
            relationshipId
          }
        }).then(response => response.data.token);
      },
      exchangePublicToken(body) {
        return sendRequest({
          apiHost: APIHost.Plaid,
          method: 'post',
          url: '/exchange-public-token',
          allowedForAccountants: true,
          data: body,
          disableSentry: err => err.isPlaidError()
        }).then(mapResponseBody);
      },
      async verifyMicroDeposit(fundingSourceId) {
        await sendRequest({
          apiHost: APIHost.Plaid,
          method: 'post',
          url: "/verify/".concat(fundingSourceId),
          urlForSentry: '/verify/:fundingSourceId',
          allowedForAccountants: true
        });
      },
      async failedVerification(fundingSourceId) {
        await sendRequest({
          apiHost: APIHost.Plaid,
          method: 'post',
          url: "/failed-verification/".concat(fundingSourceId),
          urlForSentry: '/verify-failed/:fundingSourceId',
          allowedForAccountants: true
        });
      },
      isLoginRequired(fundingSourceId) {
        return sendRequest({
          apiHost: APIHost.Plaid,
          method: 'post',
          url: "/funding-source/".concat(fundingSourceId, "/is-login-required"),
          urlForSentry: '/funging-source/:fundingSourceId/is-login-required',
          allowedForAccountants: true
        }).then(res => res.data.isLoginRequired);
      },
      async loginRepaired(fundingSourceId) {
        await sendRequest({
          apiHost: APIHost.Plaid,
          method: 'post',
          url: "/funding-source/".concat(fundingSourceId, "/login-repaired"),
          urlForSentry: '/funging-source/:fundingSourceId/login-repaired',
          allowedForAccountants: true
        });
      }
    },
    proposalTemplates: {
      async getAll() {
        if (!selectors.user.hasBusiness(getState())) {
          // Server response is 403 if user has no business.
          return [];
        }
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/proposal-templates/all"
        }).then(mapResponseBody).then(templates => templates.map(ProposalTemplateSummaryModel.fromDTO));
      },
      async get(id) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/proposal-templates/".concat(id),
          urlForSentry: '/proposal-templates/:id'
        }).then(mapResponseBody).then(proposalTemplateModel.fromDTO);
      },
      async save(id, template) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/proposal-templates/".concat(id),
          urlForSentry: '/proposal-templates/:id',
          data: template,
          disableSentry: err => err.hasServerError(ServerError.NameAlreadyExists)
        }).then(mapResponseBody);
      },
      async rename(id, title) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/proposal-templates/".concat(id, "/rename"),
          urlForSentry: '/proposal-templates/:id/rename',
          data: {
            title
          },
          disableSentry: err => err.hasServerError(ServerError.NameAlreadyExists)
        }).then(mapResponseBody);
      },
      async remove(id) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/proposal-templates/".concat(id, "/delete"),
          urlForSentry: '/proposal-templates/:id/delete'
        }).then(mapResponseBody);
      },
      async create(template) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/proposal-templates/create",
          urlForSentry: '/proposal-templates/create',
          data: template,
          disableSentry: err => err.hasServerError(ServerError.NameAlreadyExists)
        }).then(mapResponseBody);
      },
      async createDraft(id) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/proposal-templates/".concat(id, "/create-relationship-draft"),
          urlForSentry: '/proposal-templates/:id/create-relationship-draft'
        }).then(mapResponseBody);
      },
      async createFromDraft(id, title) {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/proposal-templates/create-from-draft/".concat(id),
          urlForSentry: '/proposal-templates/create-from-draft/:id',
          disableSentry: err => err.hasServerError(ServerError.NameAlreadyExists),
          data: {
            title
          }
        }).then(mapResponseBody);
      }
    },
    reports: {
      async revenueReportServices() {
        return sendRequest({
          method: 'get',
          url: "/revenue-report/services",
          apiHost: APIHost.Scout
        }).then(mapResponseBody).catch(() => []);
      },
      async revenueReportCustomers() {
        return sendRequest({
          method: 'get',
          url: "/revenue-report/customers",
          apiHost: APIHost.Scout
        }).then(mapResponseBody).catch(() => []);
      },
      async revenueReport(_ref33) {
        let {
          start,
          end,
          breakdowns,
          aggregate,
          services,
          customers,
          sort
        } = _ref33;
        const params = {
          start,
          end,
          breakdowns,
          aggregate,
          sort
        };
        const queryParams = Object.entries(params).filter(_ref34 => {
          let [, value] = _ref34;
          return !!value;
        }).map(_ref35 => {
          let [key, value] = _ref35;
          return "".concat(key, "=").concat(value);
        }).join('&');
        return sendRequest({
          method: 'post',
          url: "/revenue-report".concat(queryParams !== '' ? "?".concat(queryParams) : ''),
          apiHost: APIHost.Scout,
          data: {
            services: services.length > 0 ? services : undefined,
            customers: customers.length > 0 ? customers : undefined
          }
        }).then(mapResponseBody).catch(() => []);
      },
      async revenueReportServicesV2() {
        return sendRequest({
          method: 'get',
          url: "/revenue-report/services/v2",
          apiHost: APIHost.Scout
        }).then(mapResponseBody).catch(() => []);
      },
      async revenueReportCustomersV2() {
        return sendRequest({
          method: 'get',
          url: "/revenue-report/customers/v2",
          apiHost: APIHost.Scout
        }).then(mapResponseBody).catch(() => []);
      },
      async revenueReportV2(_ref36) {
        let {
          start,
          end,
          breakdowns,
          aggregate,
          services,
          customers,
          sort
        } = _ref36;
        const params = {
          start,
          end,
          breakdowns,
          aggregate,
          sort
        };
        const queryParams = Object.entries(params).filter(_ref37 => {
          let [, value] = _ref37;
          return !!value;
        }).map(_ref38 => {
          let [key, value] = _ref38;
          return "".concat(key, "=").concat(value);
        }).join('&');
        return sendRequest({
          method: 'post',
          url: "/revenue-report/v2".concat(queryParams !== '' ? "?".concat(queryParams) : ''),
          apiHost: APIHost.Scout,
          data: {
            services: services.length > 0 ? services : undefined,
            customers: customers.length > 0 ? customers : undefined
          }
        }).then(mapResponseBody).catch(() => []);
      },
      async activeServicesReportServices() {
        return sendRequest({
          method: 'get',
          url: "/active-services-report/services",
          apiHost: APIHost.Scout
        }).then(mapResponseBody).catch(() => []);
      },
      async activeServicesReportCustomers() {
        return sendRequest({
          method: 'get',
          url: "/active-services-report/customers",
          apiHost: APIHost.Scout
        }).then(mapResponseBody).catch(() => []);
      },
      async activeServicesReportAgreements() {
        return sendRequest({
          method: 'get',
          url: "/active-services-report/agreements",
          apiHost: APIHost.Scout
        }).then(mapResponseBody).catch(() => []);
      },
      async activeServicesReportAssignees() {
        return sendRequest({
          method: 'get',
          url: "/active-services-report/assignees",
          apiHost: APIHost.Scout
        }).then(mapResponseBody).catch(() => []);
      },
      async activeServicesReport(_ref39) {
        let {
          businessId,
          params,
          services,
          customers,
          agreements,
          assignees
        } = _ref39;
        const queryParams = Object.entries(params).filter(_ref40 => {
          let [, value] = _ref40;
          return value !== undefined;
        }).map(_ref41 => {
          let [key, value] = _ref41;
          return Array.isArray(value) ? "".concat(key, "=").concat(value.join(',')) : "".concat(key, "=").concat(value);
        }).join('&');
        return sendRequest({
          method: 'post',
          url: "/businesses/".concat(businessId, "/active-services-report").concat(queryParams !== '' ? "?".concat(queryParams) : ''),
          urlForSentry: '/businesses/:businessId/active-services-report',
          apiHost: APIHost.Scout,
          data: {
            services: services.length > 0 ? services : undefined,
            customers: customers.length > 0 ? customers : undefined,
            agreements: agreements.length > 0 ? agreements : undefined,
            assignees: assignees.length > 0 ? assignees : undefined
          }
        }).then(mapResponseBody).catch(() => []);
      },
      async remainingCreditReportServices() {
        return sendRequest({
          method: 'get',
          url: "/remaining-credit-report/services",
          apiHost: APIHost.Scout
        }).then(mapResponseBody).catch(() => []);
      },
      async remainingCreditReportCustomers() {
        return sendRequest({
          method: 'get',
          url: "/remaining-credit-report/customers",
          apiHost: APIHost.Scout
        }).then(mapResponseBody).catch(() => []);
      },
      async remainingCreditReportAgreements() {
        return sendRequest({
          method: 'get',
          url: "/remaining-credit-report/agreements",
          apiHost: APIHost.Scout
        }).then(mapResponseBody).catch(() => []);
      },
      async remainingCreditReport(_ref42) {
        let {
          services,
          customers,
          agreements,
          sort
        } = _ref42;
        return sendRequest({
          method: 'post',
          url: "/remaining-credit-report",
          apiHost: APIHost.Scout,
          data: {
            services: services.length > 0 ? services : undefined,
            customers: customers.length > 0 ? customers : undefined,
            agreements: agreements.length > 0 ? customers : undefined,
            sort
          }
        }).then(mapResponseBody).catch(() => []);
      },
      async getFutureInvoicesReport(params) {
        const serializeArray = array => array && array.length > 0 ? array.join(',') : undefined;
        return sendRequest({
          method: 'get',
          url: '/future-invoices',
          urlForSentry: '/future-invoices',
          apiHost: APIHost.Scout,
          params: {
            companyName: serializeArray(params.companies),
            agreementName: serializeArray(params.agreements),
            requiresApproval: serializeArray(params.requiresApproval),
            issueDateFrom: params.issueDateFrom,
            issueDateTo: params.issueDateTo,
            dueDateFrom: params.dueDateFrom,
            dueDateTo: params.dueDateTo,
            sortField: params.sortField,
            sortDirection: params.sortDirection
          }
        }).then(res => res.data.map(FutureInvoiceModel.fromDTO));
      },
      async getFutureInvoicesCompanyNames() {
        return sendRequest({
          method: 'get',
          url: '/future-invoices/company-names',
          apiHost: APIHost.Scout
        }).then(mapResponseBody);
      },
      async getFutureInvoicesAgreementNames() {
        return sendRequest({
          method: 'get',
          url: '/future-invoices/agreement-names',
          apiHost: APIHost.Scout
        }).then(mapResponseBody);
      }
    },
    karbon: {
      async setAPIKey(apiKey) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/integrations/karbon',
          urlForSentry: '/integrations/karbon',
          data: {
            type: 'apiKey',
            apiKey: {
              key: apiKey
            }
          }
        });
      },
      async disconnect() {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/integrations/karbon/disconnect',
          urlForSentry: '/integrations/karbon/disconnect'
        });
      },
      async getItems() {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/integrations/karbon/items',
          urlForSentry: '/integrations/karbon/items'
        });
        return res.data.status === IntegrationResponseStatus.Success ? res.data.items : [];
      },
      async linkServiceTemplate(id, integratedIds) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/integrations/karbon/items/link',
          urlForSentry: '/integrations/karbon/items/link',
          data: {
            id,
            integratedIds
          }
        });
      },
      async getRoles(serviceTemplateId) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/integrations/karbon/".concat(serviceTemplateId, "/roles"),
          urlForSentry: "/integrations/karbon/serviceTemplateId/roles"
        });
        return res.data.status === IntegrationResponseStatus.Success ? res.data.roles || [] : [];
      },
      async getUsers() {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/integrations/karbon/users',
          urlForSentry: '/integrations/karbon/users'
        });
        return res.data.status === IntegrationResponseStatus.Success ? res.data.users || [] : [];
      },
      async updateKarbonIntegration(defaultAssigneeId) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: "/integrations/karbon/update",
          urlForSentry: '/integrations/karbon/update',
          data: {
            source: 'karbon',
            karbon: {
              defaultAssigneeId
            }
          }
        });
      },
      async getIntegration() {
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/integrations/karbon",
          urlForSentry: '/integrations/karbon'
        }).then(mapResponseBody);
      }
    },
    clientHub: {
      async setAPIKey(apiKey) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/integrations/client-hub',
          urlForSentry: '/integrations/client-hub',
          data: {
            type: 'apiKey',
            apiKey: {
              key: apiKey
            }
          }
        });
      },
      async disconnect() {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/integrations/client-hub/disconnect',
          urlForSentry: '/integrations/client-hub/disconnect'
        });
      },
      async getItems() {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/integrations/client-hub/items',
          urlForSentry: '/integrations/client-hub/items'
        });
        return res.data.status === IntegrationResponseStatus.Success ? res.data.items : [];
      },
      async linkServiceTemplate(id, integratedIds) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/integrations/client-hub/items/link',
          urlForSentry: '/integrations/client-hub/items/link',
          data: {
            id,
            integratedIds
          }
        });
      },
      async getRoles(serviceTemplateId) {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: "/integrations/client-hub/".concat(serviceTemplateId, "/roles"),
          urlForSentry: "/integrations/client-hub/serviceTemplateId/roles"
        });
        return res.data.status === IntegrationResponseStatus.Success ? res.data.roles || [] : [];
      },
      async getUsers() {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/integrations/client-hub/users',
          urlForSentry: '/integrations/client-hub/users'
        });
        return res.data.status === IntegrationResponseStatus.Success ? res.data.users || [] : [];
      }
    },
    keeper: {
      async connect(_ref43) {
        let {
          clientId,
          clientSecret
        } = _ref43;
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/integrations/keeper',
          data: {
            type: 'accessToken',
            accessToken: {
              clientId,
              clientSecret
            }
          },
          disableSentry: err => err.hasServerError(ServerError.InvalidKeeperCredentials)
        });
      },
      async disconnect() {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/integrations/keeper/disconnect'
        });
      },
      async getItems() {
        const res = await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'get',
          url: '/integrations/keeper/items'
        });
        return res.data.status === IntegrationResponseStatus.Success ? res.data.items || [] : [];
      },
      async linkServiceTemplate(id, integratedIds) {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/integrations/keeper/items/link',
          data: {
            id,
            integratedIds
          }
        });
      }
    },
    xero: {
      async connect(_ref44) {
        let {
          redirectUrl
        } = _ref44;
        return sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/integrations/accounting/xero/connect',
          data: {
            redirectUrl
          }
        }).then(mapResponseBody);
      },
      async disconnect() {
        await sendRequest({
          apiHost: APIHost.Mgmt,
          method: 'post',
          url: '/integrations/accounting/xero/disconnect'
        }).then(mapResponseBody);
      }
    }
  };
}